import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import Teaxtarea from "../../../components/elements/form/textarea";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import mapImg from "../../../images/map-left.jpg";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import toast from "react-hot-toast";
import { useFacilitiesApi } from "../../../store/api/hooks/facilitiesApiHook";
import { getSelectedOption } from "../../../_common/functions";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { GoogleMap, LoadScript, Marker, useJsApiLoader } from '@react-google-maps/api';
import { MAP_KEY } from "../../../_config";
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from "../../../store/selectors/masterSelector";
import { useVendorsApi } from "../../../store/api/hooks/vendorsApiHook";
import { useSagesApi } from "../../../store/api/hooks/sageApiHook";
import { get } from "http";
import moment from "moment";

interface AssetsFormProps {
	_ref?: any;
	editData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
	actionType?: "edit" | "duplicate" | 'add' | "convert-to-owned" | null;
}

type AssetsFormValueType = {
	assetID?: number;
	assetCode: string;
	name: string;
	assetDescription: string;
	facilityID: Option;
	sageFacilityID: Option;
	subFacilityID: any;
	assetCategoryID: Option;
	departmentID: Option;
	assetGroupID: Option;
	assetSubGroupID: Option;
	assetTypeID: Option;
	assetClassificationID: Option;
	purchaseDate: Date | null;
	purchaseCost: string;
	vendorID: Option;
	manufacturer: string;
	modelName: string;
	partNumber: string;
	registrationNumber: string;
	lat: string;
	long: string;
	vinNumber: string;
	vehicleTitleNumber: string;
	vehicleTitleCountyID: string;
	vehicleRegistrationNumber: string;
	vehicleLastInspection: Date;
	assetImage: any;
	statusID: Option;
};

const CreateAssets: React.FC<AssetsFormProps> = ({ _ref, editData, actionType, onCreate = () => { }, onCancel = () => { } }) => {

	const { isLoaded } = useJsApiLoader({
		id: 'asset-map-script',
		googleMapsApiKey: MAP_KEY,
	})


	const { control, handleSubmit, setValue, reset, formState: { errors }, watch } = useForm<AssetsFormValueType>({
		defaultValues: {}
	});
	const { showLoader, hideLoader } = useAppLoader();
	const [assetCode, setassetCode] = useState<any>(null);
	const [statusList, setstatusList] = useState<any>([]);
	const [facilityoption, setFacilityoption] = useState<any>([]);
	const [sagefacilityoption, setSagefacilityoption] = useState<Option[]>([]);

	const [vendorlist, setvendorList] = useState<any>([]);
	const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
	const [allSageFacilities, setAllSageFacilities] = useState<Option[]>([]);
	const [assetRowData, setAssetRowData] = useState<Option[]>([]);

	const assetsCategories = useAssestCategoriesSelector();
	const assetsDepartments = useAssestDepartmentsSelector();
	const assetsGroups = useAssestGroupsSelector();
	const assetsSubGroups = useAssestSubGroupsSelector();
	const assetsTypes = useAssestTypesSelector();
	const assetsClassifications = useAssestClassificationsSelector();
	const assetsStatues = useAssestStatuesSelector();

	const defaultLatitude = 40.712776; // Example default latitude (New York)
	const defaultLongitude = -74.005974; // Example default longitude (New York)

	const assetApi: any = useAssetsApi();
	const facilityApi: any = useFacilitiesApi();
	const vendorsApi = useVendorsApi();
	const sageApi: any = useSagesApi();

	const facilityWatch = watch("facilityID");
	const assetCategoryIDWatch = watch("assetCategoryID");

	const isVicheleOptions = [{ label: 'Yes', value: 4 }, { label: 'No', value: 1 }]// // Assuming '4' is the ID for vehicle category


	// --- Purchase Cost formatting logic ---
	const purchaseCostValue = watch("purchaseCost");
	const [displayPurchaseCost, setDisplayPurchaseCost] = React.useState("");


	useEffect(() => {
		if (assetsCategories == null) {
			assetApi.getAssetCategpry({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsCategories]);

	useEffect(() => {
		if (assetsDepartments == null) {
			assetApi.getAssetdepartment({pageSize: 5000,
                pageNumber: 1,}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsDepartments]);

	useEffect(() => {
		if (assetsGroups == null) {
			assetApi.getAssetGrouplist({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsGroups]);

	useEffect(() => {
		if (assetsSubGroups == null) {
			assetApi.getAssetSubGrouplist({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsSubGroups]);

	useEffect(() => {
		if (assetsTypes == null) {
			assetApi.GetAssetTypeList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsTypes]);

	useEffect(() => {
		if (assetsClassifications == null) {
			assetApi.GetAssetClassificationList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsClassifications]);

	useEffect(() => {
		if (assetsStatues == null) {
			assetApi.GetAssetStatusList({}, (resp: any) => { }, (error: any) => { });
		}
	}, [assetsStatues]);


	const getAssetCode = () => {
		const payload = {};
		assetApi.getAssetCode(
			payload,
			(resp: any) => {
				setassetCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const GetAssetStatusList = () => {
		const payload = {};
		assetApi.GetAssetStatusList(
			payload,
			(resp: any) => {
				let deptlist: any = [];
				console.log("resp.assetStatusList.filter((o:any) => o.isVisible)", resp.assetStatusList.filter((o: any) => o.isVisible))
				resp.assetStatusList.filter((o: any) => o.isVisible).map((facilist: any) => {
					deptlist.push({
						label: facilist.statusName,
						value: facilist.statusID,
					});
				});
				setstatusList(deptlist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};


	/* const GetvenderList = () => {
		const payload = {};
		assetApi.GetvenderList(
			payload,
			(resp: any) => {
				let deptlist: any = [];

				resp.vendorList.map((facilist: any) => {
					deptlist.push({
						label: facilist.name,
						value: facilist.vendorID,
					});
				});
				setvendorList(deptlist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	}; */
	const GetvenderList = () => {
		const payload = {
			vendorServiceTypeIDs: [6],
			searchParam: ``
		};
		vendorsApi.FilteredServiceProviderList(
			payload,
			(resp: any) => {
				if (resp && resp.hasOwnProperty(`successful`) && resp.successful && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
					let vendorlist: any = [];

					resp.vendorList.map((vendor: any) => {
						vendorlist.push({
							label: vendor.name,
							value: vendor.vendorID,
						});
					});
					setvendorList(vendorlist);
				}
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getsubfacilityList = (_facilityID: any) => {
		const payload = { facilityID: _facilityID };
		facilityApi.getSubFacilityList(payload, (resp: any) => {
			let subfacilityoption: any = resp?.subFacilityList?.map((countylist: any) => {
				return {
					label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
					value: countylist.subFacilityID,
				}
			});

			setsubfacilityoption(subfacilityoption);
			if (editData) {
				console.log('..............', getSelectedOption(editData.subFacilityID, subfacilityoption))
				setValue("subFacilityID", getSelectedOption(editData.subFacilityID, subfacilityoption));
			}

		}, (error: any) => {
			console.log('error =>', error);
			setsubfacilityoption([]);
			toast.error(error);
		});

	}

	const getAllSageFacilities = () => {
		const payload = {};
		sageApi.getSageFacilityList(
			payload,
			(resp: any) => {
				const options =
					resp.facilityList?.map((f: any) => ({
						label: f.facilityName,
						value: f.facilityID,
					})) || [];
				setAllSageFacilities(options);
			},
			(err: any) => toast.error(err)
		);
	};

	const getSageFacilityByFacility = (facilityID: number) => {
		const payload = { facilitID: facilityID };
		sageApi.getSageFacilityList(
			payload,
			(resp: any) => {
				if (resp.facilityList?.length === 1) {
					const f = resp.facilityList[0];
					if (f) { // null check
						const single = {
							label: f.facilityName,
							value: String(f.facilityID), // string hisebe
						};
						// <--- REPLACE OLD LINE WITH THIS
						if (!editData || actionType === 'add') { // only auto-select in add mode
							setValue("sageFacilityID", single);
						}
					}
				} else {
					if (!editData || actionType === 'add') {
						setValue("sageFacilityID", null); // multiple records, no auto-select
					}
				}
			},
			(err: any) => toast.error(err)
		);
	};

	const getAssetsList = () => {
		const payload = {
			assetID: editData.assetID
		};

		return new Promise((resolve, reject) => {
			assetApi.getAssetsList(
				payload,
				(data: any) => {
					setAssetRowData(data.assetList ? data.assetList : []);
					resolve(data);
				},
				(error: any) => {
					reject(error);
				}
			);
		});
	};




	const onSubmit: SubmitHandler<AssetsFormValueType> = async (data) => {

		if (editData && editData?.assetID) {
			try {
				const assetData: any = await getAssetsList();
				const currentAsset = assetData?.assetList?.[0];
				
				// Check if asset is GAPP posted and sage facility has changed
				if (currentAsset?.isGAPPPostedToSage) {
					console.log("Asset is GAPP posted, checking validations...");
					
					if (currentAsset?.sageFacilityIDForAccounting !== data.sageFacilityID?.value) {
						toast.error("Cannot change Sage Facility for assets that are posted to SAGE");
						return;
					}
					
					// Check if ownership type has changed
					if (currentAsset?.assetGroupID !== data.assetGroupID?.value) {
						toast.error("Cannot change Ownership Type for assets that are posted to SAGE");
						return;
					}
					
					// Check if purchase date has changed
					const currentPurchaseDate = currentAsset?.purchaseDate ? new Date(currentAsset.purchaseDate).toDateString() : null;
					const newPurchaseDate = data.purchaseDate ? new Date(data.purchaseDate).toDateString() : null;
					if (currentPurchaseDate !== newPurchaseDate) {
						toast.error("Cannot change Purchase / Acquisition Date for assets that are posted to SAGE");
						return;
					}
					
					// Check if purchase cost has changed
					if (Number(currentAsset?.purchaseCost) !== Number(data.purchaseCost)) {
						toast.error("Cannot change Purchase Cost for assets that are posted to SAGE");
						return;
					}
					
					console.log("All validations passed, proceeding with save...");
				}
			} catch (error) {
				toast.error("Failed to fetch asset data");
				return;
			}
		}

		let payload: any = {
			"assetCode": editData && actionType === 'edit' ? editData.assetCode : assetCode,
			"name": data.name,
			"assetDescription": data.assetDescription,
			"facilityID": data.facilityID?.value,
			"sageFacilityID": data.sageFacilityID?.value,
			"subFacilityID": data.subFacilityID?.value,
			"assetCategoryID": data.assetCategoryID?.value,
			"departmentID": data.departmentID?.value,
			"assetGroupID": data.assetGroupID?.value,
			"assetSubGroupID": data.assetSubGroupID?.value,
			//"assetTypeID": data.assetTypeID?.value,
			//"assetClassificationID": data.assetClassificationID?.value,
			"purchaseDate": moment.utc(data.purchaseDate).local().format('YYYY-MM-DD HH:mm:ss'),
			"purchaseCost": data.purchaseCost,
			"vendorID": data.vendorID?.value,
			"manufacturer": data.manufacturer,
			"modelName": data.modelName,
			"partNumber": data.partNumber,
			"registrationNumber": data.registrationNumber,
			"lat": 0,
			"long": 0,

			// "vinNumber": "string",
			// "vehicleTitleNumber": "string",
			// "vehicleTitleCountyID": 0,
			// "vehicleRegistrationNumber": "string",
			// "vehicleLastInspection": "2025-03-13T15:40:25.434Z",
			"statusID": data.statusID?.value
		}
		if (data.assetCategoryID?.value == '4') {
			payload['vinNumber'] = data.vinNumber;
			payload['vehicleTitleNumber'] = data.vehicleTitleNumber;
			payload['vehicleTitleCountyID'] = data.vehicleTitleCountyID;
			payload['vehicleRegistrationNumber'] = data.vehicleRegistrationNumber;
			payload['vehicleLastInspection'] = data.vehicleLastInspection;
		} else {
			payload['vinNumber'] = null;
			payload['vehicleTitleNumber'] = null;
			payload['vehicleTitleCountyID'] = null;
			payload['vehicleRegistrationNumber'] = null;
			payload['vehicleLastInspection'] = null;
		}
		if (editData && editData?.assetID) {
			payload['assetID'] = editData.assetID;
			payload['statusID'] = editData?.statusID === 9 || editData?.statusID === 7 ? editData?.statusID : payload['statusID']; // if WIP or status 7, keep it unchanged
		}
		showLoader();

		// Check if this is a convert to owned asset operation
		if (actionType === 'convert-to-owned' && editData?.assetID) {
			// Prepare payload for convert to owned asset API
			const convertPayload = {
				"oldAssetID": editData.assetID,
				"assetCode": assetCode,
				"name": data.name,
				"assetDescription": data.assetDescription,
				"facilityID": data.facilityID?.value,
				"sageFacilityID": data.sageFacilityID?.value,
				"subFacilityID": data.subFacilityID?.value,
				"assetCategoryID": data.assetCategoryID?.value,
				"departmentID": data.departmentID?.value,
				"assetGroupID": 1,
				"assetSubGroupID": data.assetSubGroupID?.value,
				"assetTypeID": data.assetTypeID?.value,
				"assetClassificationID": data.assetClassificationID?.value,
				"purchaseDate": moment.utc(data.purchaseDate).local().format('YYYY-MM-DD HH:mm:ss'),
				"purchaseCost": data.purchaseCost,
				"vendorID": data.vendorID?.value,
				"manufacturer": data.manufacturer,
				"modelName": data.modelName,
				"partNumber": data.partNumber,
				"registrationNumber": data.registrationNumber,
				"lat": 0,
				"long": 0,
				"vinNumber": data.assetCategoryID?.value == '4' ? data.vinNumber : null,
				"vehicleTitleNumber": data.assetCategoryID?.value == '4' ? data.vehicleTitleNumber : null,
				"vehicleTitleCountyID": data.assetCategoryID?.value == '4' ? data.vehicleTitleCountyID : null,
				"vehicleRegistrationNumber": data.assetCategoryID?.value == '4' ? data.vehicleRegistrationNumber : null,
				"vehicleLastInspection": data.assetCategoryID?.value == '4' ? data.vehicleLastInspection : null,
				"statusID": data.statusID?.value,
				"assetStatusID": data.statusID?.value
			};

			console.log("Convert to owned asset payload:", convertPayload);
			console.log("Calling convertToOwnedAsset API...");

			assetApi.convertToOwnedAsset(convertPayload, (resp: any) => {
				console.log("convertToOwnedAsset API response:", resp);
				const formData = new FormData();
				if (data.assetImage instanceof File) {
					formData.append('inputFile', data.assetImage);
					formData.append('assetID', resp?.returnID || resp?.assetID);
					assetApi.SaveAssetImage(formData, (resp: any) => {
						toast.success(resp?.message)
						onCreate();
						formReset();
						hideLoader();
					}, (error: any) => {
						hideLoader();
						toast.error(error);
					})
				} else {
					onCreate();
					onCancel();
					toast.success(resp?.message)
					formReset();
					hideLoader();
				}
			}, (error: any) => {
				console.log('convertToOwnedAsset API error =>', error);
				hideLoader();
				toast.error(error);
			});
		} else {
			// Use normal save asset API for other actions
			assetApi.saveAssets(payload, (resp: any) => {

			const formData = new FormData();
			if (data.assetImage instanceof File) {
				formData.append('inputFile', data.assetImage);
				formData.append('assetID', (editData && editData?.assetID) ? editData.assetID : resp?.returnID);
				assetApi.SaveAssetImage(formData, (resp: any) => {
					toast.success(resp?.message)
					onCreate();
					formReset();
					hideLoader();

				}, (error: any) => {
					hideLoader();
					toast.error(error);

				})

			}


			onCreate();
			onCancel();
			console.log(resp, "Submited resp")
			toast.success(resp?.message)
			formReset();
			hideLoader();

		}, (error: any) => {
			console.log('error =>', error);
			hideLoader();
			toast.error(error);
		});
		}
		console.log("Submit payload", payload);

	};

	useEffect(() => {
		GetAssetStatusList();
		getfacilitylist();
		getAllSageFacilities();
		GetvenderList();

		if (!editData || actionType === 'duplicate' || actionType === 'convert-to-owned') {
			getAssetCode();
		}
	}, []);


	useEffect(() => {
		if (facilityWatch) {
			setValue("subFacilityID", null);
			getsubfacilityList(facilityWatch.value);
			if (!editData) {
				getSageFacilityByFacility(facilityWatch.value as any);
			}
			//console.log("fsfsfsf wwww",facilityWatch?.data?.latitude);
		}
	}, [facilityWatch]);

	const formReset = () => {
		const defaultStatus = statusList.find((status: any) => status.value === 1) || { label: 'Operational', value: 1 };
		reset({
			name: "",
			assetDescription: "",
			sageFacilityID: null,
			facilityID: null,
			subFacilityID: null,
			assetCategoryID: null,
			departmentID: null,
			assetGroupID: null,
			assetSubGroupID: null,
			//assetTypeID: null,
			//assetClassificationID: null,
			purchaseDate: null,
			purchaseCost: "",
			vendorID: null,
			manufacturer: "",
			modelName: "",
			partNumber: "",
			registrationNumber: "",
			statusID: defaultStatus,
			assetImage: '',
		});
	}

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref])

	useEffect(() => {
		if (editData == null) {
			formReset();
		}
	}, [editData]);




	useEffect(() => {
		if (editData) {
			const defaultStatus = statusList.find((status: any) => status.value === 1) || { label: 'Operational', value: 1 };
			reset({
				name: editData.name,
				assetDescription: editData.assetDescription,
				facilityID: getSelectedOption(editData.facilityID, facilityoption),
				sageFacilityID: getSelectedOption(editData.sageFacilityIDForAccounting, allSageFacilities),
				// subFacilityID: getSelectedOption(editData.subFacilityID, subfacilitylist),
				assetCategoryID: getSelectedOption(editData.assetCategoryID, isVicheleOptions),
				departmentID: getSelectedOption(editData.departmentID, assetsDepartments ? assetsDepartments : []),
				assetGroupID: getSelectedOption(editData.assetGroupID, assetsGroups ? assetsGroups : []),
				assetSubGroupID: getSelectedOption(editData.assetSubGroupID, assetsSubGroups ? assetsSubGroups : []),
				//assetTypeID: getSelectedOption(editData.assetTypeID, assetsTypes?assetsTypes:[]),
				//assetClassificationID: getSelectedOption(editData.assetClassificationID, assetsClassifications?assetsClassifications:[]),
				purchaseDate: editData.purchaseDate ? moment(editData.purchaseDate, 'YYYY-MM-DD HH:mm:ss').toDate() : null,
				purchaseCost: editData.purchaseCost,
				vendorID: getSelectedOption(editData.vendorID, vendorlist),
				manufacturer: editData.manufacturer,
				modelName: editData.modelName,
				partNumber: editData.partNumber,
				registrationNumber: editData.registrationNumber,
				assetImage: editData.imageFullPath,
				statusID: actionType === 'duplicate' ? defaultStatus : getSelectedOption(editData.statusID, assetsStatues ? assetsStatues : []),
			});
			if (editData.assetCategoryID == '4') {
				setValue("vinNumber", editData.vinNumber);
				setValue("vehicleTitleNumber", editData.vehicleTitleNumber);
				setValue("vehicleTitleCountyID", editData.vehicleTitleCountyID);
				setValue("vehicleRegistrationNumber", editData.vehicleRegistrationNumber);
				setValue("vehicleLastInspection", editData.vehicleLastInspection);
				// payload['vinNumber'] = data.vinNumber;
				// payload['vehicleTitleNumber'] = data.vehicleTitleNumber;
				// payload['vehicleTitleCountyID'] = data.vehicleTitleCountyID;
				// payload['vehicleRegistrationNumber'] = data.vehicleRegistrationNumber;
				// payload['vehicleLastInspection'] = data.vehicleLastInspection;

			}
		} else {
			formReset();
		}
	}, [editData, facilityoption, assetsCategories, assetsDepartments, assetsGroups, assetsSubGroups, assetsTypes, assetsClassifications, assetsStatues, vendorlist, allSageFacilities]);


	return (

		<form onSubmit={handleSubmit(onSubmit)} ref={_ref} className="flex flex-col h-full">
			<div className="flex-1 overflow-auto">
				<h4 className="font-semibold text-[0.938rem] border-b border-gray-200 py-4 uppercase"> Basic Information </h4>
				{
					editData && editData?.assetID && <div className="bg-green-50 py-2 px-3">
						<h6 className="text-[0.813rem] font-semibold">Asset ID</h6>
						<p className="text-[0.813rem] font-normal mt-2">{editData?.assetCode}</p>
					</div>
				}

				<Controller
					name="name"
					control={control}
					rules={{ required: "Name Required" }}
					render={({ field: { value, onChange } }) => (
						<Input
							label="Name"
							type="text"
							value={value}
							onChange={onChange}
							required
							placeholder="Write Asset Name Here"
							error={errors.name?.message}
						/>
					)}
				/>
				<Controller
					name="assetDescription"
					rules={{ required: "Description is required" }}
					control={control}
					render={({ field: { value, onChange } }) => (
						<Teaxtarea
							label="Description"
							value={value}
							onChange={onChange}
							required
							placeholder="Write Your Asset Description Here"
							error={errors.assetDescription?.message}
						/>
					)}
				/>
				<Controller
					name="facilityID"
					control={control}
					rules={{ required: "Facility is required" }}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Select Facility"
							value={value}
							onChange={onChange}
							required
							placeholder="Choose Facility"
							disabled={editData && actionType !== 'duplicate' ? true : false}
							options={facilityoption}
							error={errors.facilityID?.message as any}
						/>
					)}
				/>


				<Controller
					name="subFacilityID"
					control={control}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Select Sub Facility"
							onChange={onChange}
							value={value}
							placeholder="Choose Sub Facility"
							disabled={editData && actionType !== 'duplicate' ? true : false}
							options={subfacilitylist}
							error={errors.subFacilityID?.message as any}
						/>
					)}
				/>


				<Controller
					name="sageFacilityID"
					control={control}
					rules={{ required: "Sage Facility is required" }}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Select Sage Facility"
							value={value}
							onChange={onChange}
							required
							disabled={editData?.isGAPPPostedToSage && actionType !== 'duplicate'}
							placeholder="Choose Sage Facility"
							options={allSageFacilities}   // always full list
							error={errors?.sageFacilityID?.message as any}
						/>
					)}
				/>




				{facilityWatch && (
					<p className="text-[0.813rem] font-medium text-primary py-4">
						{facilityWatch?.data?.addressLine1}
					</p>
				)}

				{/* {(() => {
					try {
						return (
							<div className={`w-full mb-2 p-1 border border-gray-300 rounded-md ${!facilityWatch ? `hidden` : ``}`}>
								{facilityWatch && (
									(typeof window !== 'undefined' && window?.google && window.google?.maps) ? (
										<GoogleMap
											mapContainerStyle={{
												width: '100%',
												height: '200px',
											}}
											center={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }}
											zoom={15}
											mapTypeId="satellite"
										>
											<Marker position={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }} />
										</GoogleMap>
									) : (
										<LoadScript googleMapsApiKey={MAP_KEY}>
											<GoogleMap
												mapContainerStyle={{
													width: '100%',
													height: '200px',
												}}
												center={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }}
												zoom={15}
												mapTypeId="satellite"
											>
												<Marker position={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }} />
											</GoogleMap>
										</LoadScript>
									)
								)}
							</div>
						)
					} catch (errx) {
						return (<>Map Error</>)
					}
				})()} */}

				{(isLoaded && facilityWatch && typeof facilityWatch !== "undefined") && (
					<div className={`w-full mb-2 p-1 border border-gray-300 rounded-md ${!facilityWatch ? `hidden` : ``}`}>

						{(typeof window !== 'undefined' && window?.google && window.google?.maps) && (
							<GoogleMap
								mapContainerStyle={{
									width: '100%',
									height: '200px',
								}}
								center={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }}
								zoom={15}
								mapTypeId="satellite"
							>
								<Marker position={{ lat: facilityWatch?.data?.latitude ?? defaultLatitude, lng: facilityWatch?.data?.longitude ?? defaultLongitude }} />
							</GoogleMap>
						)}

					</div>
				)
				}



				<div className="grid grid-cols-2 gap-2">
					<Controller
						name="assetCategoryID"
						rules={{ required: "Category is required" }}
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Vehicle"
								value={value}
								onChange={onChange}
								required
								placeholder="Choose Yes/No"
								options={isVicheleOptions}
								error={errors.assetCategoryID?.message as any}
							/>
						)}
					/>
					<Controller
						name="departmentID"
						rules={{ required: "Department is required" }}
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Department"
								value={value}
								onChange={onChange}
								required
								placeholder="Choose Department"
								options={assetsDepartments ? assetsDepartments : []}
								error={errors.departmentID?.message as any}
							/>
						)}
					/>
				</div>

				{assetCategoryIDWatch?.value == '4' && (
					<>
						<hr className="border-gray-900" />
						<h4 className="font-semibold text-[0.938rem] py-8 uppercase">
							Vehicle Information
						</h4>
						<div className="grid grid-cols-2 gap-2">
							<Controller
								name="vinNumber"
								rules={{ required: "Vin Number is required" }}

								control={control}
								render={({ field: { value, onChange } }) => (
									<Input
										label="Vin Number"
										type="text"
										value={value}
										required
										onChange={onChange}
										placeholder="Write Vin Number Here"
										error={errors.vinNumber?.message}
									/>
								)}
							/>

							<Controller
								name="vehicleTitleNumber"
								rules={{ required: "Title Number is required" }}
								control={control}
								render={({ field: { value, onChange } }) => (
									<Input
										label="Title Number"
										type="text"
										value={value}
										required
										onChange={onChange}
										placeholder="Write Title Number Here"
										error={errors.vehicleTitleNumber?.message}
									/>
								)}
							/>

							<Controller
								name="vehicleTitleCountyID"
								rules={{ required: "Title Number is required" }}
								control={control}
								render={({ field: { value, onChange } }) => (
									<Input
										label="Title County"
										type="text"
										value={value}
										required
										onChange={onChange}
										placeholder="Write Title County Here"
										error={errors.vehicleTitleCountyID?.message}
									/>
								)}
							/>


							<Controller
								name="vehicleRegistrationNumber"
								rules={{ required: "Registration Number is required" }}

								control={control}
								render={({ field: { value, onChange } }) => (
									<Input
										label="Registration Number"
										type="text"
										value={value}
										onChange={onChange}
										required
										placeholder="Write Registration Number Here"
										error={errors.vehicleRegistrationNumber?.message}
									/>
								)}
							/>



							<Controller
								name="vehicleLastInspection"
								//rules={{ required: "Last Inspection Date is required" }}
								control={control}
								render={({ field: { value, onChange } }) => (
									<Datepicker
										label="Last Inspection Date"
										value={value}
										//required
										onChange={onChange}
									//error={errors.vehicleLastInspection?.message}
									/>

								)}
							/>

						</div>
					</>
				)}
				<hr className="border-gray-900" />
				<h4 className="font-semibold text-[0.938rem] py-8 uppercase">
					Asset Group Information
				</h4>
				<div className="grid grid-cols-2 gap-2">
					<Controller
						name="assetGroupID"
						control={control}
						rules={{ required: "Ownership Type is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Ownership Type"
								value={value}
								onChange={onChange}
								required
								placeholder="Choose Ownership Type"
								className="mb-0"
								options={assetsGroups ? assetsGroups : []}
								error={errors.assetGroupID?.message as any}
								disabled={editData?.isGAPPPostedToSage && actionType !== 'duplicate'}
							/>
						)}
					/>
					<Controller
						name="assetSubGroupID"
						control={control}
						rules={{ required: "Asset Group is required" }}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Asset Group"
								value={value}
								onChange={onChange}
								required
								placeholder="Choose Asset Group"
								className="mb-0"
								options={assetsSubGroups ? assetsSubGroups : []}
								error={errors.assetSubGroupID?.message as any}
								disabled={editData?.isGAPPPostedToSage && actionType !== 'duplicate'}
							/>
						)}
					/>
					{/* <Controller
						name="assetTypeID"
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Asset Type"
								value={value}
								onChange={onChange}
								placeholder="Choose Type"
								className="mt-0"
								options={assetsTypes?assetsTypes:[]}
								error={errors.assetTypeID?.message as any}
							/>
						)}
					/>
					<Controller
						name="assetClassificationID"
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Asset Classification"
								value={value}
								onChange={onChange}
								placeholder="Choose Classification"
								className="mt-0"
								options={assetsClassifications?assetsClassifications:[]}
								error={errors.assetClassificationID?.message as any}
							/>
						)}
					/> */}
				</div>
				<hr className="border-gray-900 mt-6" />
				<h4 className="font-semibold text-[0.938rem] py-8 uppercase">
					Purchase Information
				</h4>
				<div className="grid grid-cols-2 gap-2">
					<Controller
						name="purchaseDate"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Datepicker
								label="Purchase / Acquisition Date"
								value={value}
								onChange={onChange}
								error={errors.purchaseDate?.message}
								disabled={editData?.isGAPPPostedToSage && actionType !== 'duplicate'}
							/>
						)}
					/>
					{/* <Controller
						name="purchaseCost"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Input
								label="Purchase Cost"
								type="number"
								value={value}
								onChange={onChange}
								placeholder="Write Purchase Cost Here"
								error={errors.purchaseCost?.message}
							/>
						)}
					/> */}

					<div className={`my-6`}>
						<p className={`font-normal text-[0.938rem] leading-none`}>Purchase Cost</p>
						<div className={`flex`}>
							<div className={`pt-2`}><span className={`font-semibold w-9 border border-gray-200 h-[46px] flex items-center justify-center rounded-tl-md rounded-bl-md border-r-0`}>$</span></div>
							<Controller
								name="purchaseCost"
								control={control}
								// rules={{ required: 'Cost Per Unit Required' }}
								render={({ field: { value, onChange } }) => (
									<Input
										label={``}
										type="number" // keep as text to allow decimal typing
										value={value}
										onChange={onChange}
										placeholder="0.00"
										disabled={editData?.isGAPPPostedToSage && actionType !== 'duplicate'}
										error={errors.purchaseCost?.message as any}
										className={`text-right !rounded-md !border-gray-300 w-full !my-0 input-no-spinner`}
									/>
								)}
							/>
						</div>
					</div>
				</div>
				<Controller
					name="vendorID"
					control={control}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Vendor Name"
							value={value}
							onChange={onChange}
							placeholder="Choose Vendor Name"
							className="mt-0"
							options={vendorlist}
							error={errors.vendorID?.message as any}
						/>
					)}
				/>
				{/* <hr className='border-gray-900' />
                <h4 className='font-semibold text-[0.938rem] py-8 uppercase'>Warranty Information</h4>
                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name=''
                        control={control}
                        render={({ field :{value,onChange} }) => (
                            <Datepicker 
                            label='Warranty Start Date'
                            value={value}
                            onChange={onChange}
                            />
                        )}
                    />
                    <Controller
                        name='purchaseDate'
                        control={control}
                        render={({ field :{value,onChange} }) => (
                            <Datepicker 
                            label='Warranty End Date'
                            value={value}
                            onChange={onChange}
                            />
                        )}
                    />
                </div>
                <Controller
                    name='assetName'
                    control={control}
                    render={({ field :{value,onChange} }) => (
                        <Input 
                        label='Vendor Name'
                        type='text'
                        value={value}
                        onChange={onChange}
                        placeholder='Write Vendor Name Here'
                         />
                    )}
                /> */}
				<hr className="border-gray-900" />
				<h4 className="font-semibold text-[0.938rem] py-8 uppercase">
					Asset Identity
				</h4>
				<div className="grid grid-cols-2 gap-2">
					<Controller
						name="manufacturer"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Input
								label="Manufacturer"
								type="text"
								value={value}
								onChange={onChange}
								placeholder="Write Manufacturer Name Here"
								error={errors.manufacturer?.message}
							/>
						)}
					/>
					<Controller
						name="modelName"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Input
								label="Model Name"
								type="text"
								value={value}
								onChange={onChange}
								placeholder="Write Model Name Here"
								error={errors.modelName?.message}
							/>
						)}
					/>
					<Controller
						name="partNumber"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Input
								label="Part Number"
								type="text"
								value={value}
								onChange={onChange}
								placeholder="Write Part Number Here"
								error={errors.partNumber?.message}
							/>
						)}
					/>
					<Controller
						name="registrationNumber"
						control={control}
						render={({ field: { value, onChange } }) => (
							<Input
								label="Registration Number"
								type="text"
								value={value}
								onChange={onChange}
								placeholder="Write Registration Number Here"
								error={errors.registrationNumber?.message}
							/>
						)}
					/>
					<Controller
						name='assetImage'
						control={control}
						render={({ field: { value, onChange } }) => (
							<FileUpload
								label='Upload Asset Image'
								value={value}
								accept=".jpg, .jpeg, .png"
								onChange={(e: any) => {
									onChange(e.target.files[0])
								}}
								placeholder='Choose Processing Facility'

							/>
						)}
					/>
					{/* <Controller
						name="statusID"
						rules={{ required: "Status Required" }}
						control={control}
						render={({ field: { value, onChange } }) => (
							<SelectBox
								label="Current Status"
								value={value}
								onChange={onChange}
								required
								placeholder="Choose Current Status"
								options={statusList ? statusList : []}
								error={errors.statusID?.message as any}
							/>
						)}
					/> */}
					<Controller
						name="statusID"
						rules={
							!editData
								? { required: "Status Required" } // Add mode → always required
								: editData?.statusID === 9 || editData?.statusID === 7
									? {} // Edit mode + statusID = 9 or 7 → no rule
									: { required: "Status Required" } // Edit mode + other values → required
						}
						control={control}
						render={({ field: { value, onChange } }) =>
							((editData?.statusID === 9 || editData?.statusID === 7) && actionType !== 'duplicate') ? (
								<>
									{/* Show disabled input only for statusID = 9 or 7 */}
									<Input
										label="Current Status"
										type="text"
										value={editData?.statusName}
										onChange={onChange}
										disabled
									/>

									{/* Hidden input to keep value in form */}
									<input type="hidden" value={editData?.statusID} {...{ onChange }} />
								</>
							) : (
								<SelectBox
									label="Current Status"
									value={value}
									onChange={onChange}
									required
									placeholder="Choose Current Status"
									options={statusList || []}
									error={errors.statusID?.message as any}
								/>
							)
						}
					/>
				</div>

			</div>
			<div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
				<Button type="button" theme="secondary" onClick={() => {
					formReset();
					onCancel()
				}}>
					Cancel
				</Button>
				<Button type="submit" working={false}>
					Save
				</Button>
			</div>
		</form>
	);
};

export default CreateAssets;
